import React, { useEffect, useState, useRef } from 'react'
import { API, graphqlOperation } from 'aws-amplify'
import Suggestions from './Suggestions'
import Spin from 'antd/lib/spin'
import useOutsideClick from '../../hooks/useClickOutside'
import { useGenerateAdminHSKWithoutSuper } from '../../customHooks'

import Search from 'antd/lib/input/Search'

const MIN_PREFIX = 2
const DEBOUNCE_MS = 300

const operation = `query SearchUsers($d1: String!, $prefix: String!) {
    searchUsers(d1: $d1, prefix: $prefix) {
        items {
            userPk
            occupancyD2
            firstName
            lastName
            email
            buildingId
            tenantId
        }
    }
}`

const D1_KEYS = [
    'clientId', 'regionId', 'propertyId',
    'buildingId', 'tenantId', 'floor', 'suite',
]

const styles = {
    container: {
        width: '100%',
        position: 'relative'
    },
    error: {
        display: 'block',
        textAlign: 'center',
        color: 'red'
    },
    notFound: {
        width: '100%',
        height: '100%',
        display: 'block',
        textAlign: 'center',
        wordWrap: 'break-all',
        whiteSpace: 'normal'
    },
    // input: {
    //     marginTop: 15
    // },
    suggestionBox: {
        backgroundColor: 'white',
        width: '100%',
        boxShadow: 'rgba(0, 0, 0, 0.12) 0px 2px 10px, rgba(0, 0, 0, 0.16) 0px 2px 5px',
        borderRadius: 5,
        marginTop: -12,
        textAlign: 'center'
    }
}

const parseD1 = (d1) => {
    const parts = (d1 ?? '').split('#')
    return D1_KEYS.reduce((acc, key, i) => {
        const v = parts[i]
        acc[key] = v && v !== 'null' && v !== 'undefined' ? v : null
        return acc
    }, {})
}

const SearchInput = ({ onClick }) => {
    const ref = useRef()
    const timerRef = useRef(null)
    const requestId = useRef(0)

    const hsk = useGenerateAdminHSKWithoutSuper()

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [search, setSearch] = useState('')

    useOutsideClick(ref, () => setData([]))

    useEffect(() => () => clearTimeout(timerRef.current), [])

    const fetchData = async (term) => {
        const id = ++requestId.current
        try {
            const response = await API.graphql(
                graphqlOperation(operation, {
                    d1: hsk,
                    prefix: term,
                })
            )
            if (id !== requestId.current) return
            setData(response?.data?.searchUsers?.items ?? [])
        } catch (err) {
            if (id === requestId.current) setData([])
            console.error('error: ', err)
        } finally {
            if (id === requestId.current) setLoading(false)
        }
    }

    const onChange = (value) => {
        setSearch(value)
        clearTimeout(timerRef.current)

        const term = value.trim().toLowerCase()
        if (term.length < MIN_PREFIX) {
            setData([])
            setLoading(false)
            return
        }

        setLoading(true)
        timerRef.current = setTimeout(() => fetchData(term), DEBOUNCE_MS)
    }

    const onSelect = (item) => {
        setData([])
        setSearch('')
        onClick(item)
    }

    return (
        <div ref={ref} style={styles.container}>
            <Search
                placeholder="Name or email..."
                autoComplete="off"
                allowClear
                loading={loading}
                value={search}
                onChange={(e) => onChange(e.target.value)}
            />
            {(loading || data.length > 0) && (
                <div style={styles.suggestionBox}>
                    {loading
                        ? <Spin />
                        : <Suggestions data={data} onSelect={onSelect} />}
                </div>
            )}
        </div>
    )
}

export default SearchInput